import { type HTMLAttributes, type ReactNode, forwardRef } from 'react';
import { SectionWrapper } from './SectionContainer.styles';
import { CollapsibleContent } from './components/CollapsibleContent';
import { GrowableContent } from './components/GrowableContent';
import { SectionHeader } from './components/SectionHeader';

const SectionContainerBase = forwardRef<HTMLDivElement, { children: ReactNode; rest?: HTMLAttributes<HTMLDivElement> }>(
  ({ children, ...rest }, ref) => {
    return (
      <SectionWrapper ref={ref} {...rest}>
        {children}
      </SectionWrapper>
    );
  },
);

SectionContainerBase.displayName = 'SectionContainer';

const SectionContainer = Object.assign(SectionContainerBase, {
  Header: SectionHeader,
  GrowableContent,
  CollapsibleContent,
});

export { SectionContainer };
